import { addPrecision, removePrecision } from "helpers/precisionHelper";
import { warrantyFormatter } from "helpers/warrantyFormatter";
import { Tire } from "types/tire";

interface Props {
  tire: Tire;
  navigateToProductDetailsPage: () => void;
}
export const SearchResultsGridItemInfo = ({
  tire,
  navigateToProductDetailsPage,
}: Props) => {
  return (
    <>
      <div>
        Size: <span className="ta-font-bold">{tire.DisplayTireSize}</span>
      </div>
      <div>
        Item #:{" "}
        <button
          type="button"
          className="ta-text-link ta-underline"
          onClick={navigateToProductDetailsPage}
        >
          {tire.ManufacturerPartNumber}
        </button>
      </div>
      <div>
        Load: <span className="ta-font-bold">{tire.LoadRating}</span>
        <span className="ta-ml-2">
          Speed: <span className="ta-font-bold">{tire.SpeedRating}</span>
        </span>
      </div>
      <div>
        Mileage Warranty:{" "}
        <span className="ta-font-bold">
          {tire.Warranty === null || tire.Warranty === "0"
            ? "None"
            : warrantyFormatter(tire.Warranty) + " Miles"}
        </span>
      </div>
      <div>
        Sidewall: <span className="ta-font-bold">{tire.SideWall}</span>
      </div>
      <div>
        Load Ply: <span className="ta-font-bold">{tire.PlyRating}</span>
      </div>
      <div>
        UTQG: <span className="ta-font-bold">{tire.UTQG}</span>
      </div>
      <div>
        Tread Depth:{" "}
        <span className="ta-font-bold">{addPrecision(tire.TreadDepth)}</span>
      </div>
    </>
  );
};
